import React, { useRef } from "react";

function getFileExtension(fileName) {
  return fileName
    .substring(fileName.lastIndexOf(".") + 1)
    .trim()
    .toLocaleLowerCase();
}

const Image = ({ file, removeItemHandle, uploadErrors }) => {
  const imgContainerRef = useRef(null);

  const fileExtension = getFileExtension(file.name);
  const imgsExtensions = ["png", "jpg", "jpeg"];

  return file.size < 20000000 ? (
    <div
      ref={imgContainerRef}
      className="file-item"
      onClick={() => imgContainerRef.current.classList.toggle("active")}
      title={file.name}
    >
      {imgsExtensions.indexOf(fileExtension) >= 0 ? (
        <img alt={`img - ${file.id}`} src={file.src} className="file-img" />
      ) : (
        <i className="fas fa-file-image"></i>
      )}
      <i
        className="fas fa-times-circle close_btn"
        onClick={(e) => removeItemHandle(e, file)}
      ></i>
    </div>
  ) : (
    <div ref={imgContainerRef} className="file-item error">
      Zbyt duży rozmiar pliku.
      <i className="fas fa-exclamation-circle close_btn"></i>
    </div>
  );
};

export default Image;
